import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './FindPassword.css';

const FindPassword = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    // 실제로는 API 호출 필요
  };

  return (
    <div className="findpw-container">
      <div className="findpw-box">
        <div className="findpw-icon-box">
        <div className="findpw-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-user w-8 h-8 text-white" aria-hidden="true"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
        </div>
        </div>
        
        <h1 className="findpw-title">비밀번호 찾기</h1>
        <p className="findpw-desc">가입한 이메일로 비밀번호 재설정 링크를 보내드립니다</p>
        <button className="findpw-back" onClick={() => navigate('/Admin')}>← 로그인으로 돌아가기</button>
        <form className="findpw-form" onSubmit={handleSubmit}>
          <label htmlFor="findpw-email" className="findpw-label">이메일 *</label>
          <input
            id="findpw-email"
            type="email"
            className="findpw-input"
            placeholder="가입한 이메일을 입력하세요"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
          <div className="findpw-info-box">
            <div className="findpw-info-title">비밀번호 재설정 안내</div>
            입력하신 이메일로 비밀번호 재설정 링크를 발송해드립니다. 이 메일을 확인하시고 링크를 클릭하여 새 비밀번호를 설정해주세요.
          </div>
          <button type="submit" className="findpw-submit-btn">비밀번호 재설정 링크 발송</button>
          {submitted && <div className="findpw-success">이메일로 재설정 링크가 발송되었습니다.</div>}
        </form>
      </div>
    </div>
  );
};

export default FindPassword; 